import type {
  MasonryActionException,
  MasonryActionResult,
} from '../types/masonry-engine-action.types';

/**
 * Given the result of a chained `invokeInnerAction` call, returns a flat array
 * in execution order.
 *
 * - If `chainResult` is not an object result with `isSuccess` (including
 *   `undefined`, `null`, a thrown value, or `MasonryActionException`), returns
 *   `[chainResult]` — always a single-element array.
 * - Otherwise returns `[immediateResult, ...chainedActionResults]` where
 *   `immediateResult` is the same object without the `chainedActionResults`
 *   property, followed by nested chain entries.
 */
export const collectChainedActionResults = (
  chainResult: MasonryActionResult | MasonryActionException,
): Array<MasonryActionResult | MasonryActionException> => {
  if (
    typeof chainResult !== 'object' ||
    chainResult === null ||
    !('isSuccess' in chainResult)
  ) {
    return [chainResult];
  }

  const { chainedActionResults: nested, ...entry } = chainResult;
  return [entry, ...(nested ?? [])];
};
